// extracted by mini-css-extract-plugin
export default {"buttonContainer":"BeginButton_buttonContainer__g4eD4","beginButton":"BeginButton_beginButton__wE6CJ"};